<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <validation-provider
            name="services"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group :class="{ 'has-error': errors.length > 0 }">
              <label>Services</label>

              <Select2
                placeholder="Please select type of services"
                v-model="services_selected"
                :options="services"
              />
              <small v-show="errors.length > 0" class="text-danger">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-card>
    <validation-observer ref="requestEstimateRules">
      <b-card v-if="services_selected == 3">
        <!-- Form LCL -->
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              name="POL"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>POL<font class="text-danger">*</font></label>

                <!-- <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  class="w-100"
                  placeholder="POL"
                  v-model="request_quotation.pol_port"
                  :options="ports"
                /> -->
                <Select4
                  v-model="request_quotation.pol_port"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="POL"
                  :options="{
                    value: 'code',
                    label: 'name',
                    data: ports,
                    fields: [
                      { field: 'code', label: 'Code' },
                      { field: 'name', label: 'Name' },
                      { field: 'type', label: 'Service' },
                      {
                        field: 'country_code',
                        label: 'Country Code',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="POD"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>POD <font class="text-danger">*</font></label>
                <!-- <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="POD"
                  v-model="request_quotation.pod_port"
                  :options="ports"
                /> -->
                <Select4
                  v-model="request_quotation.pod_port"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="POD"
                  :options="{
                    value: 'code',
                    label: 'name',
                    data: ports,
                    fields: [
                      { field: 'code', label: 'Code' },
                      { field: 'name', label: 'Name' },
                      { field: 'type', label: 'Service' },
                      {
                        field: 'country_code',
                        label: 'Country Code',
                      },
                    ],
                  }"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Gross Weight (kgs)"
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label>Total Gross Weight (kg)</label>
                <cleave
                  :state="errors.length > 0 ? false : null"
                  :options="$Utils.CONSTANTS.cleaveNumeral"
                  v-model="request_quotation.trong_luong"
                  class="form-control"
                  placeholder="Gross Weight (kgs)"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <b-form-group>
              <label>Measurement (cbm)</label>
              <cleave
                :options="$Utils.CONSTANTS.cleaveNumeral"
                v-model="request_quotation.so_khoi"
                class="form-control"
                placeholder="Measurement (kgs)"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <button class="btn btn-success round" @click="getEstimate">
              {{ $t("search") }}
            </button>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="services_selected == 7">
        <!-- Form LCL -->
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Pick up"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>Pick up<font class="text-danger">*</font></label>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Pick up"
                  v-model="request_quotation.pickup_region"
                  :options="regions"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Delivery"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>Delivery<font class="text-danger">*</font></label>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Delivery"
                  v-model="request_quotation.delivery_region"
                  :options="regions"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Container Type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>Container Type <font class="text-danger">*</font></label>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  :disabled="readonly"
                  placeholder="Container Type"
                  v-model="request_quotation.cont_type"
                  :options="
                    cont_types.filter((i) => i.group === 'Container truck')
                  "
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Gross Weight (kgs)"
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label>Total Gross Weight (kg)</label>
                <cleave
                  :state="errors.length > 0 ? false : null"
                  :options="$Utils.CONSTANTS.cleaveNumeral"
                  v-model="request_quotation.trong_luong"
                  class="form-control"
                  placeholder="Gross Weight (kgs)"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <button class="btn btn-success round" @click="getEstimate">
              {{ $t("search") }}
            </button>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="services_selected == 6">
        <!-- Form LCL -->
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Pick up"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>Pick up<font class="text-danger">*</font></label>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Pick up"
                  v-model="request_quotation.pickup_region"
                  :options="regions"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Delivery"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>Delivery<font class="text-danger">*</font></label>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Delivery"
                  v-model="request_quotation.delivery_region"
                  :options="regions"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Truck Type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>Truck Type</label>
                <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  :disabled="readonly"
                  placeholder="Truck Type"
                  v-model="request_quotation.truck_type"
                  :options="cont_types.filter((i) => i.group === 'van truck')"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              name="Gross Weight (kgs)"
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label>Total Gross Weight (kg)</label>
                <cleave
                  :state="errors.length > 0 ? false : null"
                  :options="$Utils.CONSTANTS.cleaveNumeral"
                  v-model="request_quotation.trong_luong"
                  class="form-control"
                  placeholder="Gross Weight (kgs)"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="12" class="text-center">
            <button class="btn btn-success round" @click="getEstimate">
              {{ $t("search") }}
            </button>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
    <b-modal id="modal-coming-soon" hide-footer no-close-on-backdrop size="xl">
      <div>
        <div class="misc-wrapper">
          <div class="p-2 p-sm-3">
            <div style="gap: 100px" class="w-100 coming-soon">
              <div>
                <b-img style="width: 9vw" fluid :src="logo" alt="Logo" />
                <h1 class="mb-1 mt-3 text-primary" style="font-weight: 700">
                  COMING SOON
                </h1>
                <p class="mb-2">
                  This function is being programmed and will be updated in
                  December 2022
                </p>
                <div class="text-center mt-2">
                  <b-button
                    style="width: 140px"
                    variant="primary"
                    :to="{ path: '/' }"
                  >
                    Back
                  </b-button>
                </div>
              </div>
              <!-- image -->
              <div class="coming-img">
                <b-img
                  class="img-right"
                  fluid
                  :src="downImg"
                  alt="Coming soon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Select2 from "v-select2-component";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Select2,
  },
  data() {
    return {
      services: [
        { id: 7, text: "Container trucking" },
        { id: 3, text: "LCL" },
        { id: 6, text: "Van trucking" },
      ],
      downImg: require("@/assets/images/pages/track.png"),
      logo: require("@/assets/images/logo/logo.png"),

      services_selected: "",
      request_quotation: {},
    };
  },
  async created() {
    this.$store.dispatch("masterData/FETCH_ALL");
  },
  mounted() {},
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
    ]),
  },
  methods: {
    async getEstimate() {
      var validate = await this.$refs.requestEstimateRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      this.$bvModal.show("modal-coming-soon");
    },
  },
};
</script>

<style lang="scss">
.select2-container--default .select2-selection--single {
  border: 1px solid #d8d6de;
}
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.is-invalid .select2-selection--single {
  border: 1px solid #ea5455;
}
.is-invalid .select2-selection--single::before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
}
.select2-selection__arrow {
  background: none;
  display: none !important;
}
.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 0.85rem;
}
.vgt-table th {
  text-align: center;
}

@media (min-width: 568px) {
  .coming-soon {
    gap: 0px;
    display: flex;
    flex-direction: column-reverse;
  }
}

@media (min-width: 576px) {
  #modal-coming-soon {
    .modal-xl {
      max-width: 600px;
      width: 100% !important;
      margin-left: auto !important;
      margin-right: auto !important;
      position: fixed;
      top: 45% !important;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: auto !important;
      margin-bottom: auto !important;
    }
  }
  .coming-soon {
    display: flex;
    justify-content: center;
    flex-direction: row;

    align-items: center;
  }
  .coming-img {
    text-align: center;
    margin-top: 20px;
  }
  .img-right {
    height: 35vw;
  }
}

@media (min-width: 1200px) {
  #modal-coming-soon {
    .modal-xl {
      max-width: 1500px;

      width: 68% !important;
      margin-left: auto !important;
      margin-right: auto !important;
      position: fixed;
      top: 45% !important;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: auto !important;
      margin-bottom: auto !important;
    }
    .img-right {
      width: 25vw;
    }
    .coming-soon {
      flex-direction: row;

      display: flex;
      justify-content: center;
      align-items: center;
    }
    .img-right {
      height: 25vw;
    }
  }
}
</style>